import React from 'react';
import { Container } from '../../components/ui/Container';
export function ArabicComplaintsAndReporting() {
  return <section className="py-16 text-right md:py-24" dir="rtl" data-id="element-3659" data-mp="32n255pw47w0u">
      <Container data-id="element-3660" data-mp="2nzgzbo7uvip8">
        <article className="mx-auto max-w-4xl" data-id="element-3661" data-mp="2nzz63es59fbe">
          <h1 className="font-display text-4xl font-semibold leading-[1.5] text-ink-900 md:text-6xl" data-id="element-3662" data-mp="2nx4mfpgyfyj1">
            سياسة الشكاوى والإبلاغ
          </h1>
          <p className="mt-4 text-ink-500" data-id="element-3663" data-mp="2ey9cq3epc6az">
            <strong data-id="element-3664" data-mp="2f0ltid8q4amg">آخر تحديث:</strong> 1 فبراير 2026
          </p>

          <div className="mt-10 space-y-8 leading-loose text-ink-700" data-id="element-3665" data-mp="2jydl165ghuq4">
            <p data-id="element-3666" data-mp="250uy89cc9rlb">
              يشجّع <strong data-id="element-3667" data-mp="251ehbtdq6m0x">المركز الدولي للتعلّم الإسلامي (IILH)</strong> الملاحظات
              المفتوحة والإبلاغ المسؤول لضمان الحفاظ على معاييرنا العالية.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3668" data-mp="3985o3cstomq">
              نطاق الإبلاغ
            </h2>
            <p data-id="element-3669" data-mp="879xpds7cyac">يجوز للأفراد الإبلاغ عن مسائل تشمل، على سبيل المثال لا الحصر:</p>
            <p data-id="element-3670" data-mp="31sycul17gxvb">• مخاوف تتعلق بسلوك الموظفين أو المشاركين أو تصرفاتهم.</p>
            <p data-id="element-3671" data-mp="2wvogelfeflxz">• مسائل الحماية وحماية الطفل.</p>
            <p data-id="element-3672" data-mp="2wuwktalsxo7p">• الاشتباه في إساءة استخدام الأموال أو وجود مخالفات مالية.</p>
            <p data-id="element-3673" data-mp="3birdiqzt7sks">• مخالفات أخلاقية أو مخاوف تتعلق بالحوكمة.</p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3674" data-mp="36l80tvirfnuy">
              كيفية الإبلاغ
            </h2>
            <p data-id="element-3675" data-mp="2ivnfx731qgj1">
              ينبغي تقديم البلاغات بسرية عبر البريد الإلكتروني إلى:{' '}
              <a href="mailto:complaints@iilh.org" className="font-medium text-forest-700 underline underline-offset-2 transition hover:text-forest-800" dir="ltr" data-id="element-3676" data-mp="2dxvd3i0v5a02">
                complaints@iilh.org
              </a>
              .
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3677" data-mp="741dn0vcoh60">
              التعامل مع البلاغات
            </h2>
            <p data-id="element-3678" data-mp="2vxob6yb72v40">
              <strong data-id="element-3679" data-mp="2vxy5uz76pqg1">الحياد:</strong> يراجع مسؤول امتثال مكلّف جميع البلاغات بحياد.
            </p>
            <p data-id="element-3680" data-mp="30wj791y6ag62">
              <strong data-id="element-3681" data-mp="30vzndfoyphpe">السرية:</strong> تُحفظ هوية مقدِّم البلاغ وتفاصيله بسرية تامة.
            </p>
            <p data-id="element-3682" data-mp="35xow2ooppjab">
              <strong data-id="element-3683" data-mp="35v2t72crnryf">عدم الانتقام:</strong> يُحظر منعًا باتًا الانتقام من أي شخص يقدّم
              بلاغًا بحسن نية.
            </p>
          </div>
        </article>
      </Container>
    </section>;
}